import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../components/CsStyles";
import CssBaseline from "@material-ui/core/CssBaseline";

import { Autocomplete } from "@material-ui/lab";
import { GenericFieldNames } from "../Constants";
import { Box, Button, TextField, Grid, Typography, MenuItem, Select, Tabs, Tab } from "@material-ui/core";

import Bar from "../components/GenericUI/Bar";
import Import from "../components/GenericUI/Import";

class Generic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: "",
            parseBars: [],
            selectedTab: 0,
            finalToml: ""
        };

        // Title
        if (this.props.setTitle != null)
            this.props.setTitle("Generic");

        this.num = 0;

        this.toolBarFuncs = {
            delete: (num) => {
                this.setState({ parseBars: this.state.parseBars.filter(e => e.num != num) });
            },

            moveUp: (num) => {
                var index = this.state.parseBars.findIndex(e => e.num === num);

                if (index >= 1) {
                    var data = this.state.parseBars[index];
                    var swap = this.state.parseBars[index - 1];
                    var before = this.state.parseBars.slice(0, index - 1);
                    var after = this.state.parseBars.slice(index + 1, this.state.parseBars.length);

                    this.setState({
                        parseBars: [
                            ...before, data, swap, ...after
                        ]
                    });
                }
            },

            moveDown: (num) => {
                var index = this.state.parseBars.findIndex(e => e.num === num);

                if (index >= 0 && index < this.state.parseBars.length - 1) {
                    var data = this.state.parseBars[index];
                    var swap = this.state.parseBars[index + 1];
                    var before = this.state.parseBars.slice(0, index);
                    var after = this.state.parseBars.slice(index + 2, this.state.parseBars.length);

                    this.setState({
                        parseBars: [
                            ...before, swap, data, ...after
                        ]
                    });
                }
            },
        };
    }

    addBar(name, value, attributes) {
        var data = {
            num: this.num++,
            name: "",
            value: "",
            attributes: []
        };

        if (name !== undefined)
            data.name = name;

        if (value !== undefined)
            data.value = value;

        if (attributes !== undefined)
            data.attributes = attributes;

        this.setState((prevState) => ({
            parseBars: [...prevState.parseBars, data]
        }));
    }

    getToml(type, bars) {
        //serialize each parsebar into data
        let output = "";
        if (type != "")
            output = "type = \"" + type + "\"\n";

        bars.forEach((bar) => {
            var attrs = (bar.attributes.length > 0 ? ", " : "") + bar.attributes.map(e => e.name + (e.value ? `= '${e.value}'` : '')).join(", ");
            var str = `${bar.name} = { node = '${bar.value}'${attrs} }`;
            output += str + "\r\n";
        });

        return output;
    }

    setData = (num, value) => {
        this.setState({
            parseBars: this.state.parseBars.map(data => {
                if (data.num == num) {
                    return { ...data, ...value };
                }
                else {
                    return data;
                }
            })
        });
    }

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <CssBaseline />
                <Box style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: 'space-between',
                }}>
                    <Box
                        style={{
                            width: "50%",
                            margin: "1em",
                        }}>
                        <Box style={{ width: '100%' }}>
                            <Button id="newFieldbtn" onClick={() => this.addBar('field')}>
                                New Field
                            </Button>
                            <Button id="newLoopbtn" onClick={() => this.addBar('loop')}>
                                New Loop
                            </Button>
                            <Button id="newLinkbtn" onClick={() => this.addBar('link')}>
                                New Link
                            </Button>
                            <Button id="resetbtn" onClick={() => this.setState({ parseBars: [], type: "" })}>
                                Reset
                            </Button>
                        </Box>
                        <Box>
                            <Box
                                style={{
                                    width: "100%",
                                    margin: "1em",
                                    border: "1px solid #000",
                                    padding: "10px",
                                    'padding-left':'1em'
                                }}
                                display='block'>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <Typography variant='h6'>Type</Typography>
                                    </Grid>
                                    <Grid item xs>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={this.state.type}
                                            label="Type"
                                            onChange={e => { this.setState({ type: e.target.value }); }}>
                                            <MenuItem value={"html"}>HTML</MenuItem>
                                            <MenuItem value={"json"}>JSON</MenuItem>
                                            <MenuItem value={"xml"}>XML</MenuItem>
                                        </Select>
                                    </Grid>
                                </Grid>
                            </Box>
                            {this.state.parseBars.map((e, index) => (
                                <Box key={e.num} >
                                    <Bar data={e} setData={this.setData} funcs={this.toolBarFuncs} />
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <Box
                        style={{
                            width: "50%",
                            margin: "1em",
                        }}>
                        <Box style={{ width: '100%' }}>
                            <Autocomplete
                                disablePortal
                                style={{ width: '100%' }}
                                options={GenericFieldNames}
                                renderInput={(params) => <TextField {...params} label="Select Field" />}
                                PopperProps={{
                                    placement: 'bottom-start'
                                }}
                            />
                        </Box>
                        <Box style={{ marginTop: '1em' }}>
                            <Tabs value={this.state.selectedTab} onChange={(e, num) => this.setState({ selectedTab: num })}>
                                <Tab label="TOML" value={0} />
                                <Tab label="IMPORT" value={1} />
                            </Tabs>
                            {this.state.selectedTab === 1 && (
                                <Import container={this} />
                            )}
                            {this.state.selectedTab === 0 && (
                                <Box>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        value={this.getToml(this.state.type, this.state.parseBars)}
                                    />
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box>
            </React.Fragment>
        );
    }
}

Generic.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Generic);
